export { default as FinalSaleDisclaimer } from './FinalSaleDisclaimer'



// WEBPACK FOOTER //
// ./src/components/finalSaleDisclaimer/index.js